export const appApiUrl = '/cscec-pms-app-business'
// export const appApiUrl = '/cscec-pms-app-business-3'
// export const appApiUrl = '/cscec-pms-app-business-ycq'
export const commonApiUrl = '/cscec-common-business'
/***
 * 商务
 * @type {string}
 */
export const commercialApiUrl = '/cscec-commercial-business'
export const messageSendApiUrl = '/ycloud-mbroker'
export const processApiUrl='/cscec-pms-process'
export const organizationApiUrl='/ycloud-organization'
/***
 * 技术
 * @type {string}
 */
export const technicalApiUrl = '/cscec-technical-business'
export const projectApiUrlList = '/cscec-project-business'
/***
 * 车辆管理
 * 食堂采购
 * @type {string}
 */
export const carManagementApiUrl = '/union-producer-server'
// export const carManagementApiUrl = '/union-producer-server-zy'
// export const carManagementApiUrl = '/union-producer-server-penghong'
// export const carManagementApiUrl = '/union-producer-server-xrh'

export const qualityApiUrl = '/cscec-quality-business'

export const faceApiUrl = '/face-producer-server'

/***
 * 客服
 * @type {string}
 */
export const customerServer = '/customer-producer-server'

/***
 * 安监
 * @type {string}
 */
export const safetyApiUrl = '/cscec-safety-business'

/***
 * 物资
 * @type {string}
 */
export const materialApiUrl = '/cscec-material-business'


/**
 * 办公
 * @type {string}
 */
export const officeApiUrl = '/cscec-office-business'

/***
 * 工程
 * @type {string}
 */
export const projectApiUrl = '/cscec-project-business'
